export const searchFromBeginningFn = function (search: string, itemvalue: string): boolean {
  return new RegExp('^' + escapeRegExp(search), 'gi').exec(itemvalue) !== null;
};

export const searchWholeValueFn = function (search: string, itemvalue: string): boolean {
  return search
    .split(' ')
    .map(searchToken => new RegExp(escapeRegExp(searchToken), 'gi').exec(itemvalue) !== null)
    .reduce((prev, curr) => prev && curr, true);
};

function escapeRegExp(text: string): string {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, String.raw`\$&`);
}
